import { useQueryParams } from "@hooks/useQueryParams";
import { useMemo } from "react";

export function useUrlLink() {
  const urlLink = useQueryParams("link");
  return useMemo<string>(() => {
    return urlLink ? decodeURIComponent(urlLink) : "";
  }, [urlLink]);
}
